import Vue from 'vue'
import Vuex from 'vuex'
import dbConstructor from '../store/dbConstructor'
import auth from '../store/auth/index'
import employee from '../store/employee/index'
import db from '../store/db/index'
import userInfo from '../store/userInfo/index'
import main from '../store/main/main'
import organisation from '../store/organisation/index'

Vue.use(Vuex)

export const store = new Vuex.Store({
  namespaced: true,
  state: {
    name: ''
  },
  modules: {
    auth,
    dbConstructor,
    employee,
    db,
    userInfo,
    main,
    organisation
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js